var _mask, _path, _mask2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEditNewIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_17732_10820",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0V1.5H24V0V-1.5H8V0ZM32 8H30.5V24H32H33.5V8H32ZM24 32V30.5H8V32V33.5H24V32ZM0 24H1.5V8H0H-1.5V24H0ZM8 32V30.5C4.41015 30.5 1.5 27.5899 1.5 24H0H-1.5C-1.5 29.2467 2.75329 33.5 8 33.5V32ZM32 24H30.5C30.5 27.5899 27.5899 30.5 24 30.5V32V33.5C29.2467 33.5 33.5 29.2467 33.5 24H32ZM24 0V1.5C27.5899 1.5 30.5 4.41015 30.5 8H32H33.5C33.5 2.75329 29.2467 -1.5 24 -1.5V0ZM8 0V-1.5C2.75329 -1.5 -1.5 2.75329 -1.5 8H0H1.5C1.5 4.41015 4.41015 1.5 8 1.5V0Z",
    fill: "currentColor",
    mask: "url(#path-1-inside-1_17732_10820)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17732_10820",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 20,
    height: 20
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4109 19.0158L19.0159 10.4108C19.3409 10.0858 19.8684 10.0858 20.1934 10.4108L21.5901 11.8075C21.9151 12.1325 21.9151 12.66 21.5901 12.985L12.9842 21.5892C12.8284 21.7458 12.6167 21.8333 12.3959 21.8333H10.1667V19.6042C10.1667 19.3833 10.2542 19.1717 10.4109 19.0158Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4583 11.9667L20.0333 14.5417",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17732_10820)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 20,
    height: 20,
    fill: "currentColor"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditNewIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/EditNewIcon.99fd4267.svg";
export { ForwardRef as ReactComponent };